// extracted by mini-css-extract-plugin
export default {"lead":"V_OS_","container":"bwNEy m2rwA","leadParagraph":"MMeDI"};